import styled, { css } from 'styled-components';
import { Button } from '../../components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.6rem 4rem;

  @media (max-width: 600px) {
    padding: 1.6rem 0.8rem;
  }
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 2.5fr 3fr 1fr 0.5fr 0.5fr 0.5fr 1.5fr 1fr;
  grid-gap: 1rem;

  background: #f5f6fa;
  border-radius: 8px;
  padding: 1.4rem 2rem;
  margin-top: 1rem;

  span {
    color: #5d4e4f;
    font-size: 1.4rem;
  }

  @media (max-width: 600px) {
    grid-template-columns: 0.7fr 2fr 0.5fr;

    span:not(:nth-child(1)):not(:nth-child(2)):not(:last-child) {
      display: none;
    }
  }
`;

export const TableBody = styled.div`
  margin: 1rem 0;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 2.5fr 3fr 1fr 0.5fr 0.5fr 0.5fr 1.5fr 1fr;
  grid-gap: 1rem;

  background: #fff;
  border-radius: 8px;
  padding: 2.4rem 2rem;
  margin-bottom: 1rem;

  span {
    color: #000;
    font-size: 1.4rem;
    text-transform: uppercase;
    /* Truncate */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:first-of-type {
      color: #c4c4c4;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: 0.7fr 2fr 0.5fr;

    span:not(:nth-child(1)):not(:nth-child(2)):not(:last-child) {
      display: none;
    }
  }
`;

export const EmptyContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;
  border-radius: 8px;
  padding: 2.4rem 2rem;
  margin-bottom: 1rem;

  color: #222;
  font-size: 1.4rem;
`;

export const IconsContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;

  svg {
    cursor: pointer;
    transition: opacity 200ms;

    &:hover {
      opacity: 0.6;
    }
  }

  @media (max-width: 600px) {
    svg + svg {
      margin-left: 0.8rem;
    }
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;

  span {
    font-size: 1.4rem;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const PageButtonsContainer = styled.div`
  margin-left: 1rem;

  @media (max-width: 600px) {
    margin-left: 0;
    margin-top: 1rem;
  }
`;

export const PageButton = styled.button<{ reverse?: boolean }>`
  font-size: 1.4rem;
  background: transparent;
  border: none;
  padding: 1.2rem 1.6rem;
  margin: 0 0.2rem;
  border-radius: 0.8rem;
  transition: background 200ms, filter 200ms;
  transform: ${({ reverse }) => (reverse ? 'rotateY(180deg)' : 'rotateY(0)')};

  &:disabled {
    cursor: not-allowed;
  }

  &.active:not(:disabled) {
    background-color: #057e85;
    color: #fff;
    font-weight: bold;

    &:hover {
      filter: brightness(80%);
    }
  }

  &:hover:not(.active):not(:disabled) {
    background: #c1c1c1;
  }
`;

export const RowsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  row-gap: 1.2rem;
`;

export const InputColumnGroupGrid = styled.div<{ cols: number }>`
  ${({ cols }) => css`
    display: grid;
    grid-template-columns: repeat(${cols}, 1fr);
    grid-gap: 2rem;

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
      grid-gap: 1.2rem;
    }
  `}
`;

export const MemoText = styled.input`
  text-transform: uppercase;
  color: #5d4e4f;
`;

export const ShowTrackingButton = styled(Button)`
  background: transparent;
  height: unset;
  color: #222;
  border: none;
  font-weight: unset;
  padding: 0.4rem 0.8rem;
  font-size: 1.2rem;
  border-radius: 0.8rem;
  margin-left: auto;
  transition: all 0.2s;
  background: #8fdce1;

  &:hover:not(:disabled) {
    background: #057e85;
    color: #fff !important;
  }

  @media (max-width: 600px) {
    margin-left: 0;
    margin-right: auto;
  }
`;
